/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback, useState} from 'react';
// material
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
import SentimentAdvancedSettings from './sentiment/sentiment';
// styles
import injectSheet from 'react-jss';
import styles from './advanced_styles';



/* ========== ~~~~~~~~~~ ADVANCED CONFIG - SENTIMENT ~~~~~~~~~~ ========== */
const AdvancedConfig = injectSheet(styles)((props) => {
  const [isOpened, setIsOpened] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const handleToggle = useCallback(() => {
    setIsOpened(!isOpened);
  }, [isOpened]);

  const handleCancel = useCallback(() => {
    setIsOpened(false);
    setIsChanged(false);
  }, []);

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      isOpened={isOpened}
      isChanged={isChanged}
      title='Advanced Settings'
      description={''}
      cancelTitle={'Close'}
    />
  );
  return (
    <ExpandableSection
      className={`advancedconfig ${props.classes.advancedconfig}`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleCancel}
      cancelTitle={'Close'}
    >
      <SentimentAdvancedSettings/>
    </ExpandableSection>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdvancedConfig;
